<template>
  <div class="stock-line">
    <div class="stock-line-cell">
        <span>{{lineData.tmod}}</span>
    </div>
    <div class="stock-line-cell">
        <span>{{lineData.tlib_mod}}</span>
    </div>
    <div class="stock-line-cell">
        <span>{{lineData.ttail}}</span>
    </div>
    <div class="stock-line-cell">
        <span>{{lineData.tcol}}</span>
    </div>
    <div class="stock-line-cell">
        <span>{{lineData.tlib_opt}}</span>
    </div>
    <div class="stock-line-cell" 
        :class="{ 
          'in-stock': this.$props.dataline.TOKSTK === 1,   
          'out-of-stock': this.$props.dataline.TOKSTK === 2,   
          'contact-us': this.$props.dataline.TOKSTK === 3,   
        }">
        <span class="stock-mark"></span>
        <span>{{getLibelleStk}}</span>
    </div>
    <div class="stock-line-cell">
        <span>{{lineData.tstk}}</span>
    </div>
    <div class="stock-line-cell">
        <span>{{lineData.tstk_disp}}</span>
    </div>
    <div class="stock-line-cell">
        <span>{{this.$dateformat(lineData.tdatedisp)}}</span>
    </div>
    <div class="stock-line-cell">
      <div v-if="lineData.tmontantttc > 0">
        <span class="add-to-cart" @click="addToCart()"><i class="material-icons">shopping_cart</i></span>
        <transition name="fade">
          <span v-if="animate_button" class="add-to-cart-success"><i class="material-icons">done</i></span>
        </transition>
      </div>
      <div v-else>
        <span>{{$_('contact_us')}}</span>
      </div>
    </div>
    <div class="stock-line-cell">
      <div v-if="lineData.tmontant > 0" class="price-cell">
        <span>{{lineData.tmontant}} {{tcdev}} HT / {{lineData.tunit_prix}}</span>
        <span>{{lineData.tmontantttc}} {{tcdev}} TTC / {{lineData.tunit_prix}}</span>
      </div>
      <div v-else>
        <span>-</span>
      </div>
    </div>
  </div>
</template>

<script>

import cartService from "@/modules/panier/services/cartService";

export default {
    props: ['dataline', 'index'],
    name:'StockLine',
    data() {
      return {
        lineData: {
          tmod: this.$props.dataline.TMOD,
          tlib_mod: this.$props.dataline.TLIB_MOD,
          ttail: this.$props.dataline.TTAIL,
          tcol: this.$props.dataline.TCOL+'-'+this.$props.dataline.TMARQ,
          tlib_opt: this.$props.dataline.TLIB_OPT,
          tokstk: this.$props.dataline.TOKSTK,
          tstk: this.$props.dataline.TSTK+' '+this.$props.dataline.TUNIT_STK,
          tdatedisp: this.$props.dataline.TDATEDISP,
          tstk_disp: this.$props.dataline.TSTK_DISP+' '+this.$props.dataline.TUNIT_STK,
          tmontantttc: this.$props.dataline.TPRIXTTC,
          tmontant: this.$props.dataline.TPRIX,
          tunit_prix: this.$props.dataline.TUNIT_PRIX,
        },
        stk_libelle: '',
        animate_button: false,
        tcdev: this.$store.getters['application/get_application_customer'].TCDEV
      }
    },
    methods: {
      addToCart() {

        let p_tail = this.$props.dataline.TTAIL.split(' ');
        
        let params = {
          p_mod: this.$props.dataline.TMOD,
          p_opt: this.$props.dataline.TOPT,
          p_tail1: p_tail[0],
          p_tail2:  p_tail[1],
          p_col: this.$props.dataline.TCOL,
          p_marq: this.$props.dataline.TMARQ,
          p_qte: 1,
          pcpromo: '',
          p_sup: 0
        };

        cartService.addToCart(params)
        .then(res => {

          if(res.data !== undefined) {

            this.$store.dispatch('panier/SET', {key: 'pnbon', value: res.data.PNBON_OUT});

            this.animate_button = true;

            setTimeout(() => {
              this.animate_button = false;
            }, 2000);

            this.$store.dispatch('panier/SET', {key: 'reload_cart', value: true});
          }
        })
      }
    },
    computed: {
      getLibelleStk() {

        let libelle = ''

        switch (this.$props.dataline.TOKSTK) {
          case 1:
           libelle = this.$_('in_stock');
            break;
          case 2:
            libelle = this.$_('out_of_stock');
            break;
          case 3:
           libelle = this.$_('not_available');
            break;
        }
        return libelle;
      }
    }
}
</script>

<style scoped>
.stock-line {
  display: flex;
  border: solid 1px #E9E9E9;
  margin-top: 10px;
  transition: all .3s;
}
.stock-line-cell {
  display: flex;
  width: calc(100% / 10);
  justify-content: center;
  padding: 25px 0px;
  align-items: center;
  position: relative;
}
.stock-line-cell span {
  color:#585858;
  font-size: var(--fz-md);
  transition: all .3s;
}
.stock-line:hover {
  background-color: #F5F5F5;
  cursor: pointer;
}
.stock-line:hover .stock-line-cell span {
  color: #8B8B8B;
}
.stock-mark {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 5px;
}

.out-of-stock span {
  color: orange;
}
.out-of-stock .stock-mark {
  background-color: orange;
}
.stock-line .stock-line-cell.in-stock span {
  color: #8BC133;
}
.in-stock .stock-mark {
  background-color: #8BC133;
}
.contact-us {
  color: red;
}
.contact-us .stock-mark {
  background-color: red;
}
.add-to-cart {
  transition: all .3s;
  display: flex;
  width: 35px;
  height: 35px;
  border: solid 1px transparent;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.add-to-cart:hover {
  border: solid 1px #d0d0d0;
  border-radius: 8px;
}
.add-to-cart-success {
  background-color: #8BC133;
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 8px;
  width: 34px;
  height: 34px;
}
.add-to-cart-success i {
  color: #fff;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.price-cell span {
  display: block; 
}
</style>